import { calculateAerobicTrainingZones } from '../../AthletePage/TestsPage/zones';

// Worked example input. CSS is critical swim speed in metres per second,
// the unit zones.js divides into 100m. 1:20.00 per 100m is 1.25 m/s.
export const EXAMPLE_PACE_SECONDS = 80;
export const EXAMPLE_CSS = 100 / EXAMPLE_PACE_SECONDS;
export const EXAMPLE_CSS_LABEL = '1:20.00 / 100m';
export const REP_DISTANCES = [100, 200, 300, 400];

// zones.js formats time as mm:ss,mmm. Parse it back to seconds.
export function parseZoneTime(text) {
    const match = /^(\d+):(\d+),(\d+)$/.exec(text || '');
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]) + Number(match[3]) / 1000;
}

export function formatZoneTime(seconds) {
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    const ms = Math.round((seconds - Math.floor(seconds)) * 1000);
    return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')},${String(ms).padStart(3, '0')}`;
}

// Runs the real zones.js calculation and adds numeric seconds plus the
// CSS factor each bound corresponds to (factor = 100 / (css * seconds)).
export function buildZoneRows(distance = 100, css = EXAMPLE_CSS) {
    const zones = calculateAerobicTrainingZones(css, distance);
    return Object.values(zones).map(zone => {
        const from = parseZoneTime(zone.timeFrom);
        const to = parseZoneTime(zone.timeTo);
        const average = parseZoneTime(zone.averagePace);
        const factor = seconds => (seconds ? (100 / (css * seconds)).toFixed(2) : null);
        return {
            title: zone.title,
            subTitle: zone.subTitle,
            fromText: zone.timeFrom,
            toText: zone.timeTo,
            averageText: zone.averagePace,
            totalText: zone.totalDuration,
            from,
            to,
            average,
            factorFrom: factor(from),
            factorTo: factor(to),
            isOpenEnded: from === null
        };
    });
}
